import { Container, Grid } from '@material-ui/core';
import obituaryIcon from '@static/obituary-icon.png';
import rabiIcon from '@static/rabi-icon.png';
import refurbishIcon from '@static/refurbish-icon.png';
import tombstoneIcon from '@static/tombstone-icon.png';
import useLanguageStore from '@stores/languageStore';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import ComplementaryServiceCard from '../../components/cards/ComplementaryServiceCard';
import SEOHead from '../../components/SEOHead';
import SectionHeader from '../../components/SectionHeader';

const ServicesPage = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();
  const isRtl = language === 'he';

  const services = [
    {
      key: 'obituary',
      iconSrc: obituaryIcon,
      iconAlt: t('home.services.obituary.title'),
      buttonLink: '/obituary',
      disabled: false,
    },
    {
      key: 'tombstone',
      iconSrc: tombstoneIcon,
      iconAlt: t('home.services.tombstone.title'),
      buttonLink: '/tombstone',
      disabled: false,
    },
    {
      key: 'refurbish',
      iconSrc: refurbishIcon,
      iconAlt: t('home.services.refurbish.title'),
      buttonLink: '/refurbish',
      disabled: false,
    },
    {
      key: 'scheduleRabi',
      iconSrc: rabiIcon,
      iconAlt: t('home.services.scheduleRabi.title'),
      buttonLink: '/schedule-rabbi',
      disabled: false,
    },
  ];

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Grave Maintenance and Memorial Services",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Avne Chen",
      "image": "https://www.avnechen.org/static/hero-tomb.png"
    },
    "areaServed": {
      "@type": "Country",
      "name": "Israel"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Memorial Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tombstone Construction"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Grave Renovation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Digital Obituary"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Rabbi Scheduling for Memorial"
          }
        }
      ]
    }
  };

  return (
    <div
      className={`min-h-[calc(100vh-64px)] bg-stone-50 py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
        isRtl ? 'rtl' : 'ltr'
      }`}
    >
      <Container maxWidth="lg" className="px-4 sm:px-8">
        <SEOHead
          title={t('home.services.title')}
          description={t('home.services.subtitle')}
        />
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
        </Helmet>
        <SectionHeader
          title={t('home.services.title')}
          subtitle={t('home.services.subtitle')}
          className="mb-10"
          component="h1"
        />

        <Grid container spacing={4}>
          {services.map((service) => (
            <Grid item xs={12} sm={6} md={3} key={service.key}>
              <ComplementaryServiceCard
                title={t(`home.services.${service.key}.title`)}
                description={t(`home.services.${service.key}.description`)}
                buttonText={t(`home.services.${service.key}.button`)}
                buttonLink={service.buttonLink}
                iconSrc={service.iconSrc}
                iconAlt={service.iconAlt}
                disabled={service.disabled}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default ServicesPage;
